module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_scotland_text_01.ed80509e.jpg";